module.exports = __webpack_public_path__ + "static/media/second.3e3f365c.png";